const bolsa_solicitud = (state = [], action) => {

    switch (action.type) {
        case 'FETCH_BOLSA_SOLICITUD': return action.solicitudes
        case 'LOG_OUT': return []
        default: return state
    }
}

export const getBolsaSolicitudes = (state) => state
export const getBolsaSolicitud = (state, id) => state.reduce((p, bolsa_solicitud) => {
    if ( Number(bolsa_solicitud.id) === Number(id)) return bolsa_solicitud
    return p
}, {})

export default bolsa_solicitud